export default "__VITE_ASSET__LkSBuLaN__"